import React, { useEffect, useMemo, useRef, useState } from "react";

import "react-18-image-lightbox/style.css";
import { fetchAxiosToken } from "../../../helpers/fetchAxiosToken";
import { CapacidadesHotel } from "designs/capacidades/CapacidadesHotel";
import ResponsiveModalAbsolute from "../../../components/ResponsiveModalAbsolute";
import { formatearNumero } from "../../../components/helpers/formatearNumero";
import { usePriceToSelectedCurrency } from "../../../hooks/usePriceToSelectedCurrency";

import Spinner from "../../../components/helpers/Spinner";
import Swal from "sweetalert2";

import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Lazy } from "swiper";
import "swiper/css/lazy";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import Calendar from "react-calendar";

import getEveryDayBetween2Dates from "../../../helpers/getEveryDayBetween2Dates";
import { getEachDayPrice } from "../../../helpers/getEachDayPrice";
import { transformDatesToSlash } from "../../../helpers/transformDatesToSlash";
import useCurrencyPrices from "../../../hooks/useCurrencyPrices";

import { getPriceAditionalServicePerDay } from "designs/calendario-reserva/getPriceAditionalServicePerDay";
import { DateIsBetween2Dates } from "../../../helpers/DateIsBetween2Dates";

import { useNavigate } from "react-router-dom";
import {
    Habitacion,
    reserva,
    Reservas,
    ReservaTour,
    Servicios_adicionales,
    Tour,
} from "../../../components/helpers/types/modal_habitacion";
import ModalHuespedes from "components/helpers/ModalHuespedes";

import { ModalCupon } from "designs/modalEdit/ModalCupon";
import { calcularMinimaDisponibilidad } from "designs/calendario-reserva/calcularMinimaDisponibilidad";
import { huespedesProps } from "components/helpers/types/modal_tour";
import { useAppSelector } from "hooks/hooks";
import { Pedido } from "./ReservaDetalleHotel";

interface Props {
    modalVisible: boolean;
    setModalVisible: (b: boolean) => void;
    id_habitacion: number;
    fecha_ingreso: string;
    fecha_salida: string;
    total_huespedes: number;
    pedido: Pedido;
    getOnePedido: () => Promise<void>;
}

export const ModalHabitacion = ({
    modalVisible,
    setModalVisible,
    id_habitacion,
    fecha_ingreso,
    fecha_salida,
    total_huespedes,
    pedido,
    getOnePedido,
}: Props) => {
    const navigate = useNavigate();
    const [modalCalendar, setModalCalendar] = useState<boolean>(false);
    const [modalHuespedes, setModalHuespedes] = useState<boolean>(false);
    const [reserveVisible, setReserveVisible] = useState<boolean>(false);
    const [allDatesSelected, setAllDatesSelected] = useState<Date[]>([]);
    const [errorReserve, setErrorReserve] = useState<string | null>(null);
    const [loading, setLoading] = useState<boolean>(false);
    const [loadingHabitacion, setLoadingHabitacion] = useState<boolean>(false);
    const [tours, setTours] = useState<Tour[]>();
    const [cupon, setCupon] = useState(0);

    const [checkedInputs, setCheckedInputs] = useState<any[]>([]);

    const serviciosPedido: Servicios_adicionales[] =
        pedido.pedidos_servicios_adicionales?.map((servicio: any) => ({
            id: servicio.id,
            nombre: servicio.servicio,
            opcional: "No", // ya están elegidos
            precio: Number(servicio.costo),
            igv: Number(servicio.igv),
        })) || [];

    const toursPedido: ReservaTour[] =
        pedido.pedidos_tours?.map((tour: any) => ({
            tour: tour.hotel_tour.nombre, // Información del tour
            precio_tour_simple: Number(tour.precio_simple),
            hora_inicio: tour.hora_inicio,
            hora_final: tour.hora_final,
            precio_tour: Number(tour.precio_tour),
            fecha: tour.fecha,
            personas: {
                adultos: Number(tour.numero_adultos),
                ninos: Number(tour.numero_ninos),
            },
            precio_igv: Number(tour.precio_igv),
        })) || [];

    const [reserva, setReserva] = useState<reserva>({
        precio_alquiler: Number(pedido.costo_alquiler),
        garantia: Number(pedido.garantia),
        descuento_estadia: Number(pedido.descuento_estadia),
        descuento_cupon: Number(pedido.descuento_cupon),
        total_servicios_adicionales: Number(pedido.costo_servicios_adicionales),
        servicios_adicionales: serviciosPedido,
        reserva_tours: toursPedido,
        precio_total_reserva: Number(pedido.costo_total),
        costo_subtotal: Number(pedido.costo_subtotal),
        igv: Number(pedido.igv),
    });
    const scrollRef = useRef<HTMLDivElement>(null);
    const [habitacion, setHabitacion] = useState<Habitacion>({
        id: 0,
        nombre: "",
        descripcion: "",
        banner: "",
        precio_base: "",
        personas: "",
        plan: 2,
        mascotas: "",
        estadia_minima: 0,
        banos: "",
        camas: "",
        landing: 0,
        check_in: "",
        check_out: "",
        id_hotel: 0,
        tipo_garantia: "",
        garantia: "",
        casa: {
            id: 0,
            nombre: "",
        },
        hotel_habitaciones_imagenes: [],
        disponibilidades: {
            arrayDias: [],
            arrayFechas: [],
        },
        precios_variables: [],
        hotel_estadias_minimas: [],
        servicios_adicionales: [],
        descuentos_tiempos: [],
        personas_adicionales: [],
        pedidos: {
            arrayFechasPedido: [],
        },
    });

    const modalRef = useRef<HTMLDivElement>(null);
    const modalRefCalendar = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (modalVisible) {
            getOneHabitacion();
        }
    }, [modalVisible]);

    const getOneHabitacion = async () => {
        setLoadingHabitacion(true);
        const response = await fetchAxiosToken({
            url: `/hotel_habitaciones/detalle/${id_habitacion}`,
            method: "get",
        });

        setHabitacion(response);
        setLoadingHabitacion(false);
    };

    // Función para manejar clics fuera del modal
    const handleClickOutside = (event: MouseEvent) => {
        if (
            modalRef.current &&
            !modalRef.current.contains(event.target as Node)
        ) {
            setModalCalendar(false); // Cierra el modal
        }
    };

    const handleClickOutsideHuespedes = (event: MouseEvent) => {
        if (
            modalRefCalendar.current &&
            !modalRefCalendar.current.contains(event.target as Node)
        ) {
            setModalHuespedes(false); // Cierra el modal
        }
    };

    const [dataReseve, setDataReserve] = useState<{
        fecha_inicial: string;
        fecha_final: string;
        huespedes: number;
    }>({
        fecha_inicial: "Selecciona una fecha",
        fecha_final: "Selecciona una fecha",
        huespedes: 1,
    });

    const parseDateFromString = (
        dateStr: string,
        isEndDate = false
    ): Date | null => {
        if (!dateStr) return null;
        const [day, month, year] = dateStr.split("/").map(Number);
        if (
            !day ||
            !month ||
            !year ||
            day < 1 ||
            day > 31 ||
            month < 1 ||
            month > 12
        ) {
            console.error("Fecha inválida:", dateStr);
            return null;
        }

        const date = new Date(year, month - 1, day);

        if (isEndDate) {
            date.setHours(23, 59, 59, 999); // Establecer hora a 23:59:59.999
        }
        return date;
    };

    useEffect(() => {
        if (!loadingHabitacion) {
            let fecha_inicio_str = "Selecciona una fecha";
            let fecha_final_str = "Selecciona una fecha";
            if (fecha_ingreso !== "" && fecha_salida !== "") {
                fecha_inicio_str = fecha_ingreso;
                fecha_final_str = fecha_salida;
                let startDate: Date | null = null;
                let endDate: Date | null = null;
                if (fecha_ingreso) {
                    startDate = parseDateFromString(fecha_ingreso);
                }
                if (fecha_salida) {
                    endDate = parseDateFromString(fecha_salida, true); // Pasar true para ajustar la fecha final
                }

                if (startDate && endDate) {
                    setDatesSelected({
                        fecha_inicial: startDate,
                        fecha_final: endDate,
                    });

                    onChangeCalendar([startDate, endDate]);
                }
            }

            setDataReserve({
                fecha_inicial: fecha_inicio_str,
                fecha_final: fecha_final_str,
                huespedes: total_huespedes,
            });
        }
    }, [loadingHabitacion]);

    useEffect(() => {
        // Agregar el evento cuando el modal está activo
        if (modalCalendar) {
            document.addEventListener("mousedown", handleClickOutside);
        }

        // Eliminar el evento al desmontar o cuando el modal se cierra
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [modalCalendar]);

    useEffect(() => {
        // Agregar el evento cuando el modal está activo
        if (modalHuespedes) {
            document.addEventListener("mousedown", handleClickOutsideHuespedes);
        }

        // Eliminar el evento al desmontar o cuando el modal se cierra
        return () => {
            document.removeEventListener(
                "mousedown",
                handleClickOutsideHuespedes
            );
        };
    }, [modalHuespedes]);

    const [datesSelected, setDatesSelected] = useState<{
        fecha_inicial: Date;
        fecha_final: Date;
    } | null>(null);

    const { price_to_currency } = usePriceToSelectedCurrency();

    const formatDate = (date: Date) => {
        const day = date.getDate().toString().padStart(2, "0");
        const month = (date.getMonth() + 1).toString().padStart(2, "0"); // Mes empieza desde 0
        const year = date.getFullYear();
        return `${day}/${month}/${year}`;
    };

    const [huespedes, setHuespedes] = useState({
        adultos: 1,
        ninos: 0,
        mascotas: 0,
    });

    const onChangeCalendar = (twoDates: Date[]) => {
        const fecha_inicial = formatDate(twoDates[0]);
        const fecha_final = formatDate(twoDates[1]);

        // Actualizar estados
        setDatesSelected({
            fecha_inicial: twoDates[0],
            fecha_final: twoDates[1],
        });

        setDataReserve((prev) => ({
            ...prev,
            fecha_inicial,
            fecha_final,
        }));

        setModalCalendar(false);
        setReserveVisible(true);
        const all_dates_selected = getEveryDayBetween2Dates({
            array_fechas: twoDates,
        });

        // Precios variables por semana

        // console.log(all_dates_selectedTotal)

        if (habitacion?.precio_base) {
            let total_alquiler = all_dates_selected.reduce(
                (acc, currentDate) => {
                    return (acc += getEachDayPrice({
                        current_day: currentDate,
                        house_variable_prices:
                            2 > 1 ? habitacion.precios_variables : [],
                        base_price: Number(habitacion.precio_base),
                    }));
                },
                0
            );

            const isAvailable = calcularMinimaDisponibilidad({
                minimaDisponibilidad: habitacion.hotel_estadias_minimas,
                //Tomo el primer y el ultimo día reservado
                selected_dates: [
                    all_dates_selected[0],
                    all_dates_selected[all_dates_selected.length - 1],
                ],
                estadia_maxima: 0,
                estadia_minima: habitacion.estadia_minima,
            });

            if (all_dates_selected.length > 1) {
                all_dates_selected.pop();
            }

            setAllDatesSelected(all_dates_selected);

            const arrayFechas = habitacion.disponibilidades.arrayFechas.map(
                (fecha) => {
                    const transformFecha = transformDatesToSlash({
                        date: fecha.fecha,
                    });

                    return new Date(transformFecha).getTime();
                }
            );

            const arrayFechasPedidos = habitacion.pedidos.arrayFechasPedido
                // Filtramos para excluir el pedido actual si estás editando
                .filter(
                    (pedidoExistente: any) =>
                        pedidoExistente.id_pedido !== pedido?.id
                )
                .map((fecha: any) => {
                    const transformFecha = transformDatesToSlash({
                        date: fecha.fecha,
                    });

                    return new Date(transformFecha).getTime();
                });

            const all_days_selected = all_dates_selected.map((date) =>
                date.getDay()
            );

            const { arrayDias } = habitacion.disponibilidades;
            // if (infoCasaRedux.plan > 1) {
            if (
                all_dates_selected.some((date) =>
                    arrayFechasPedidos.includes(date.getTime())
                ) ||
                all_dates_selected.some((date) =>
                    arrayFechas.includes(date.getTime())
                ) ||
                all_days_selected.some((day) =>
                    arrayDias.some(
                        (dia) =>
                            dia.dia === day &&
                            twoDates[1] <= new Date(dia.fecha_final) &&
                            twoDates[0] >= new Date(dia.fecha_inicio)
                    )
                )
            ) {
                setErrorReserve("No puedes seleccionar fechas no disponibles");
            } else {
                if (isAvailable.some(({ available }) => available === false)) {
                    const response = isAvailable.find(
                        ({ available }) => available === false
                    );
                    setErrorReserve(response?.message || null);
                } else {
                    setErrorReserve(null);
                }
            }
            // }

            setReserva({
                ...reserva,
                garantia:
                    habitacion.tipo_garantia === "efectivo"
                        ? 0
                        : Number(habitacion?.garantia),
                precio_alquiler: total_alquiler,
            });

            const serviciosHabitacion = reserva.servicios_adicionales.map(
                (currentService: any) => {
                    const service_final_price = getPriceAditionalServicePerDay({
                        dia_inicial: new Date(fecha_inicial),
                        dia_final: new Date(fecha_final),
                        servicio_adicional: currentService,
                    });

                    return {
                        id: currentService.id,
                        nombre: currentService.nombre,
                        opcional: currentService.opcional,
                        precio: service_final_price,
                    };
                }
            );

            const total_servicios_adicionales = serviciosHabitacion.reduce(
                (acc: any, s: any) => acc + Number(s.precio),
                0
            );

            const total_nights = all_dates_selected.length;
            let descuento_estadia = 0;
            const matchDiscountFecha = habitacion.descuentos_tiempos.find(
                (descuento) => {
                    if (
                        total_nights >= descuento.dia_inicio - 1 &&
                        total_nights <= descuento.dia_final - 1 &&
                        descuento.tipo === "Fecha"
                    ) {
                        //Transformo las fechas de la base de datos a objetos new Date()
                        const nueva_fecha_inicio = new Date(
                            transformDatesToSlash({
                                date: descuento.fecha_inicio,
                            })
                        );
                        const nueva_fecha_final = new Date(
                            transformDatesToSlash({
                                date: descuento.fecha_final,
                            })
                        );

                        if (
                            all_dates_selected.some((dateSelected) => {
                                if (
                                    DateIsBetween2Dates({
                                        fecha_evaluada: dateSelected,
                                        fecha_inicio: nueva_fecha_inicio,
                                        fecha_final: nueva_fecha_final,
                                    })
                                )
                                    return true;
                            })
                        ) {
                            return descuento;
                        }
                    }
                }
            );

            //Si en matchNights encuentro uno por fechas lo uso, sino intento encontrar uno por tipo "Siempre"
            if (matchDiscountFecha) {
                descuento_estadia = Number(matchDiscountFecha.descuento);
            } else {
                const matchDiscountSiempre = habitacion.descuentos_tiempos.find(
                    (descuento) =>
                        total_nights >= descuento.dia_inicio - 1 &&
                        total_nights <= descuento.dia_final - 1 &&
                        descuento.tipo === "Siempre"
                );

                if (matchDiscountSiempre) {
                    descuento_estadia = Number(matchDiscountSiempre.descuento);
                } else {
                    descuento_estadia = 0;
                }
            }
            //Encontrar precio personas adicionales
            const matchPersonasAdicionalesFecha =
                habitacion.personas_adicionales.find((rango_persona) => {
                    if (
                        Number(dataReseve.huespedes) >=
                            Number(rango_persona.rango_inicio) &&
                        Number(dataReseve.huespedes) <=
                            Number(rango_persona.rango_final) &&
                        rango_persona.tipo === "Fecha"
                    ) {
                        //Transformo las fechas de la base de datos a objetos new Date()

                        const nueva_fecha_inicio = new Date(
                            transformDatesToSlash({
                                date: rango_persona.fecha_inicio,
                            })
                        );
                        const nueva_fecha_final = new Date(
                            transformDatesToSlash({
                                date: rango_persona.fecha_final,
                            })
                        );

                        if (
                            all_dates_selected.some((dateSelected) => {
                                if (
                                    DateIsBetween2Dates({
                                        fecha_evaluada: dateSelected,
                                        fecha_inicio: nueva_fecha_inicio,
                                        fecha_final: nueva_fecha_final,
                                    })
                                ) {
                                    return true;
                                }
                            })
                        ) {
                            return rango_persona;
                        }
                    }
                });
            let precio_personas_adicionales = 0;
            //Si en matchNights encuentro uno por fechas lo uso, sino intento encontrar uno por tipo "Siempre"
            if (matchPersonasAdicionalesFecha) {
                precio_personas_adicionales =
                    total_nights * Number(matchPersonasAdicionalesFecha.precio);
            } else {
                const matchPersonasAdicionalesSiempre =
                    habitacion.personas_adicionales.find(
                        (rango_persona) =>
                            Number(dataReseve.huespedes) >=
                                Number(rango_persona.rango_inicio) &&
                            Number(dataReseve.huespedes) <=
                                Number(rango_persona.rango_final) &&
                            rango_persona.tipo === "Siempre"
                    );

                if (matchPersonasAdicionalesSiempre) {
                    precio_personas_adicionales =
                        total_nights *
                        Number(matchPersonasAdicionalesSiempre.precio);
                } else {
                    precio_personas_adicionales = 0;
                }
            }
            total_alquiler += precio_personas_adicionales;
            const garantia =
                habitacion.tipo_garantia === "efectivo"
                    ? 0
                    : Number(habitacion?.garantia);

            const total_tours = reserva.reserva_tours?.reduce(
                (total, tour) => total + (tour.precio_tour || 0),
                0
            );

            const costo_subtotal =
                price_to_currency(total_alquiler, pedido.tipo_moneda) +
                total_tours +
                total_servicios_adicionales -
                price_to_currency(descuento_estadia, pedido.tipo_moneda) -
                price_to_currency(reserva.descuento_cupon, pedido.tipo_moneda);

            let igv =
                price_to_currency(total_alquiler, pedido.tipo_moneda) -
                price_to_currency(
                    reserva.descuento_estadia,
                    pedido.tipo_moneda
                ) -
                price_to_currency(reserva.descuento_cupon, pedido.tipo_moneda);
            igv = igv * 0.18;
            // Si existen tours, sumar su IGV
            if (
                Array.isArray(reserva.reserva_tours) &&
                reserva.reserva_tours.length > 0
            ) {
                const igvTours = reserva.reserva_tours.reduce((total, tour) => {
                    const igvTour = Number(tour.precio_igv) || 0;
                    return igvTour > 0 ? total + igvTour : total;
                }, 0);

                igv += igvTours;
            }

            // Si existen servicios adicionales, sumar su IGV
            if (
                Array.isArray(reserva.servicios_adicionales) &&
                reserva.servicios_adicionales.length > 0
            ) {
                const igvServicios = reserva.servicios_adicionales.reduce(
                    (total, servicio) => {
                        const igvServicio = Number(servicio.igv) || 0;
                        return igvServicio > 0 ? total + igvServicio : total;
                    },
                    0
                );

                igv += igvServicios;
            }

            let reservaFinal =
                price_to_currency(total_alquiler, pedido.tipo_moneda) +
                price_to_currency(garantia, pedido.tipo_moneda) +
                total_tours +
                igv +
                total_servicios_adicionales -
                price_to_currency(descuento_estadia, pedido.tipo_moneda);

            setReserva({
                ...reserva,
                garantia,
                precio_alquiler: price_to_currency(
                    total_alquiler,
                    pedido.tipo_moneda
                ),
                total_servicios_adicionales,
                descuento_estadia,
                costo_subtotal,
                igv,
                precio_total_reserva: reservaFinal,
            });
        }
    };

    const handleDeleteFechas = () => {
        setDataReserve((prev) => ({
            ...prev,
            fecha_inicial: "Selecciona una fecha",
            fecha_final: "Selecciona una fecha",
        }));
        setReserveVisible(false);
        setDatesSelected(null);
    };

    const handleModalHuespedes = () => {
        if (modalHuespedes) {
            setModalHuespedes(false); // Cierra el modal si ya está abierto
        } else {
            setModalHuespedes(true); // Abre el modal si está cerrado
        }
    };

    const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const inputValue = event.target.value;

        const newValue = inputValue !== "" ? Number(inputValue) : "";

        setHuespedes((prevHuespedes) => {
            const updatedHuespedes = {
                ...prevHuespedes,
                [event.target.name]: newValue,
            };

            // Calcular el total de huéspedes
            const totalHuespedes =
                (updatedHuespedes.adultos || 0) + (updatedHuespedes.ninos || 0);

            // Actualizar dataReseve con el total de huéspedes
            setDataReserve((prevData) => ({
                ...prevData,
                huespedes: totalHuespedes,
            }));

            return updatedHuespedes;
        });
    };

    useEffect(() => {
        let total_nights = allDatesSelected.length;

        if (total_nights > 0) {
            let total_alquiler = allDatesSelected.reduce((acc, currentDate) => {
                return (acc += getEachDayPrice({
                    current_day: currentDate,
                    house_variable_prices:
                        2 > 1 ? habitacion.precios_variables : [],
                    base_price: Number(habitacion.precio_base),
                }));
            }, 0);

            const matchPersonasAdicionalesFecha =
                habitacion.personas_adicionales.find((rango_persona) => {
                    if (
                        Number(dataReseve.huespedes) >=
                            Number(rango_persona.rango_inicio) &&
                        Number(dataReseve.huespedes) <=
                            Number(rango_persona.rango_final) &&
                        rango_persona.tipo === "Fecha"
                    ) {
                        //Transformo las fechas de la base de datos a objetos new Date()

                        const nueva_fecha_inicio = new Date(
                            transformDatesToSlash({
                                date: rango_persona.fecha_inicio,
                            })
                        );
                        const nueva_fecha_final = new Date(
                            transformDatesToSlash({
                                date: rango_persona.fecha_final,
                            })
                        );

                        if (
                            allDatesSelected.some((dateSelected) => {
                                if (
                                    DateIsBetween2Dates({
                                        fecha_evaluada: dateSelected,
                                        fecha_inicio: nueva_fecha_inicio,
                                        fecha_final: nueva_fecha_final,
                                    })
                                ) {
                                    return true;
                                }
                            })
                        ) {
                            return rango_persona;
                        }
                    }
                });
            let precio_personas_adicionales = 0;
            //Si en matchNights encuentro uno por fechas lo uso, sino intento encontrar uno por tipo "Siempre"
            if (matchPersonasAdicionalesFecha) {
                precio_personas_adicionales =
                    total_nights * Number(matchPersonasAdicionalesFecha.precio);
            } else {
                const matchPersonasAdicionalesSiempre =
                    habitacion.personas_adicionales.find(
                        (rango_persona) =>
                            Number(dataReseve.huespedes) >=
                                Number(rango_persona.rango_inicio) &&
                            Number(dataReseve.huespedes) <=
                                Number(rango_persona.rango_final) &&
                            rango_persona.tipo === "Siempre"
                    );

                if (matchPersonasAdicionalesSiempre) {
                    precio_personas_adicionales =
                        total_nights *
                        Number(matchPersonasAdicionalesSiempre.precio);
                } else {
                    precio_personas_adicionales = 0;
                }
            }

            total_alquiler = total_alquiler + precio_personas_adicionales;

            const total_tours = reserva.reserva_tours?.reduce(
                (total, tour) => total + (tour.precio_tour || 0),
                0
            );

            const costo_subtotal =
                price_to_currency(total_alquiler, pedido.tipo_moneda) +
                total_tours +
                reserva.total_servicios_adicionales -
                price_to_currency(
                    reserva.descuento_estadia,
                    pedido.tipo_moneda
                ) -
                price_to_currency(reserva.descuento_cupon, pedido.tipo_moneda);

            let igv =
                price_to_currency(total_alquiler, pedido.tipo_moneda) -
                price_to_currency(
                    reserva.descuento_estadia,
                    pedido.tipo_moneda
                ) -
                price_to_currency(reserva.descuento_cupon, pedido.tipo_moneda);

            // Si existen tours, sumar su IGV
            if (
                Array.isArray(reserva.reserva_tours) &&
                reserva.reserva_tours.length > 0
            ) {
                const igvTours = reserva.reserva_tours.reduce((total, tour) => {
                    const igvTour = Number(tour.precio_igv) || 0;
                    return igvTour > 0 ? total + igvTour : total;
                }, 0);
                igv += igvTours;
            }

            // Si existen servicios adicionales, sumar su IGV
            if (
                Array.isArray(reserva.servicios_adicionales) &&
                reserva.servicios_adicionales.length > 0
            ) {
                const igvServicios = reserva.servicios_adicionales.reduce(
                    (total, servicio) => {
                        const igvServicio = Number(servicio.igv) || 0;
                        return igvServicio > 0 ? total + igvServicio : total;
                    },
                    0
                );
                igv += igvServicios;
            }

            let reservaFinal =
                price_to_currency(total_alquiler, pedido.tipo_moneda) +
                price_to_currency(reserva.garantia, pedido.tipo_moneda) +
                total_tours +
                igv +
                reserva.total_servicios_adicionales -
                price_to_currency(
                    reserva.descuento_estadia,
                    pedido.tipo_moneda
                );

            setReserva({
                ...reserva,
                costo_subtotal,
                igv,
                precio_alquiler: price_to_currency(
                    total_alquiler,
                    pedido.tipo_moneda
                ),
                precio_total_reserva: reservaFinal,
            });
        }
    }, [dataReseve.huespedes]);

    const handleInputClick = ({ name, action }: huespedesProps) => {
        setHuespedes((prevHuespedes) => {
            const updatedHuespedes = { ...prevHuespedes };

            // Calcular el total actual de huéspedes antes de realizar cambios
            const totalHuespedesActual =
                (updatedHuespedes.adultos || 0) + (updatedHuespedes.ninos || 0);

            if (action === "sumar") {
                // Solo sumar si no excede el límite
                if (totalHuespedesActual < Number(habitacion.personas)) {
                    switch (name) {
                        case "adultos":
                            updatedHuespedes[name] += 1;
                            break;
                        case "ninos":
                            updatedHuespedes[name] += 1;
                            break;
                        case "mascotas":
                            updatedHuespedes[name] += 1;
                            break;
                        default:
                            break;
                    }
                }
            } else {
                // Restar sin restricciones pero respetando los mínimos
                switch (name) {
                    case "adultos":
                        updatedHuespedes[name] = Math.max(
                            1,
                            updatedHuespedes[name] - 1
                        );
                        break;
                    case "ninos":
                        updatedHuespedes[name] = Math.max(
                            0,
                            updatedHuespedes[name] - 1
                        );
                        break;
                    case "mascotas":
                        updatedHuespedes[name] = Math.max(
                            0,
                            updatedHuespedes[name] - 1
                        );
                        break;
                    default:
                        break;
                }
            }

            // Calcular el nuevo total de huéspedes
            const totalHuespedes =
                (updatedHuespedes.adultos || 0) + (updatedHuespedes.ninos || 0);

            setDataReserve((prevData) => ({
                ...prevData,
                huespedes: totalHuespedes,
            }));

            return updatedHuespedes;
        });
    };

    const handleSubmit = async () => {
        const TOTAL_HUESPEDES =
            Number(huespedes.adultos) + Number(huespedes.ninos);
        if (Number(huespedes.adultos) < 1) {
            return Swal.fire({
                confirmButtonColor: "#029BFC",
                iconColor: "#029BFC",
                title: "Por favor primero indica la cantidad de huéspedes",
                icon: "warning",
                confirmButtonText: "Aceptar",
            });
        }
        if (TOTAL_HUESPEDES > Number(habitacion.personas)) {
            return Swal.fire({
                confirmButtonColor: "#029BFC",
                iconColor: "#029BFC",
                title: `Solo se permiten hasta ${habitacion.personas} personas incluido niños y adultos`,
                icon: "warning",
                confirmButtonText: "Aceptar",
            });
        }

        const formatFecha = (date?: Date): string | null => {
            if (!date) return null;
            const local = new Date(
                date.getTime() - date.getTimezoneOffset() * 60000
            );
            return local.toISOString().split("T")[0];
        };
        const response = await fetchAxiosToken({
            url: `/pedidos_habitaciones/updatePedido/${pedido.id}`,

            method: "put",
            body: {
                id_pedido: pedido.id,
                fecha_inicio: formatFecha(datesSelected?.fecha_inicial),
                fecha_final: formatFecha(datesSelected?.fecha_final),
                costo_alquiler: reserva.precio_alquiler,
                descuento_estadia: reserva.descuento_estadia,
                descuento_cupon: reserva.descuento_cupon,
                costo_total: reserva.precio_total_reserva,
                costo_subtotal: reserva.costo_subtotal,
                igv: reserva.igv,
                ninos: huespedes.ninos,
                adultos: huespedes.adultos,
            },
        });

        Swal.fire({
            confirmButtonColor: "#029BFC",
            iconColor: "#029BFC",
            title: "Reserva actualizada correctamente",
            icon: "success",
            confirmButtonText: "Aceptar",
        }).then(() => {
            setModalVisible(false);
            getOnePedido();
        });
    };

    const calculateDisabledTiles = React.useMemo(
        () =>
            (date: Date): boolean => {
                if (habitacion) {
                    // Paso las fechas a formato Date
                    const mesActual = date.getMonth();

                    const disponibilidadesFechas =
                        habitacion.disponibilidades.arrayFechas.some(
                            (fecha) => {
                                return (
                                    date.getTime() ===
                                    new Date(
                                        fecha.fecha + "T00:00:00"
                                    ).getTime()
                                );
                            }
                        );

                    if (disponibilidadesFechas) return disponibilidadesFechas;

                    const disponibilidadesFechasPedidos =
                        habitacion.pedidos.arrayFechasPedido
                            .filter(
                                (pedidoExistente: any) =>
                                    pedidoExistente.id_pedido !== pedido?.id // 👈 excluimos la reserva actual
                            )
                            .some((fecha: Reservas) => {
                                return (
                                    date.getTime() ===
                                    new Date(
                                        fecha.fecha + "T00:00:00"
                                    ).getTime()
                                );
                            });

                    if (disponibilidadesFechasPedidos)
                        return disponibilidadesFechasPedidos;

                    const disponibilidadesDias =
                        habitacion.disponibilidades.arrayDias;

                    if (
                        disponibilidadesDias.some(
                            (dia) =>
                                dia.dia === date.getDay() &&
                                date <= new Date(dia.fecha_final) &&
                                date >= new Date(dia.fecha_inicio)
                        )
                    )
                        return true;
                }
                return false;
            },
        [habitacion]
    );

    const formatearFecha = (fecha: string): string => {
        const [anio, mes, dia] = fecha.split("-");
        return `${dia}/${mes}/${anio}`;
    };

    return (
        <ResponsiveModalAbsolute
            scrollRef={scrollRef}
            modalVisible={modalVisible}
            setModalVisible={setModalVisible}
            max_width={90}
        >
            <div className="flex flex-col items-center justify-center gap-4 p-4 mx-auto w-full relative ">
                {modalCalendar && (
                    <div
                        ref={modalRef}
                        className="md:w-1/3 w-11/12 absolute flex flex-col lg:top-20 top-96 h-96 p-1 items-center bg-white justify-center gap-4 z-50"
                    >
                        <Calendar
                            selectRange={true}
                            onChange={onChangeCalendar}
                            minDate={new Date()}
                            tileDisabled={({ activeStartDate, date, view }) =>
                                calculateDisabledTiles(date)
                            }
                            value={
                                datesSelected
                                    ? [
                                          datesSelected.fecha_inicial,
                                          datesSelected.fecha_final,
                                      ]
                                    : undefined
                            }
                        />

                        <div
                            onClick={handleDeleteFechas}
                            className="underline cursor-pointer text-[#1C4CBB] justify-end w-full text-right px-5"
                        >
                            Borrar fechas
                        </div>
                    </div>
                )}

                <h2 className="2xl:text-4xl text-3xl text-[#1C4CBB] text-center font-medium">
                    Habitación {habitacion?.nombre}
                </h2>
                <hr className="w-full bg-gray-300" />
                {loadingHabitacion ? (
                    <>
                        <Spinner />
                    </>
                ) : (
                    <div className="w-full h-full flex flex-col items-center justify-center gap-4 p-4 mx-auto ">
                        {habitacion && (
                            <div
                                key={`habitacion-${habitacion.id}`}
                                className={` w-full flex lg:flex-row flex-col justify-start px-5 items-start gap-10`}
                            >
                                <div className="lg:w-1/2 w-full">
                                    <Swiper
                                        key={habitacion.banner}
                                        modules={[Navigation, Lazy]}
                                        slidesPerView={1}
                                        watchSlidesProgress
                                        lazy={true}
                                        navigation
                                        rewind={true}
                                        loop={true}
                                    >
                                        <SwiperSlide
                                            key={habitacion.banner}
                                            className="cursor-pointer"
                                        >
                                            <img
                                                loading="lazy"
                                                className=" lg:h-[50vh] h-[30vh] rounded-md swiper-lazy mx-auto"
                                                alt="Imagen del producto"
                                                data-src={`${process.env.REACT_APP_PROXY_ARCHIVOS}/blu/v1/hotel_habitaciones/getImage/${habitacion.banner}`}
                                                data-srcset={`${process.env.REACT_APP_PROXY_ARCHIVOS}/blu/v1/hotel_habitaciones/getImage/${habitacion.banner}`}
                                            />

                                            <div className="swiper-lazy-preloader">
                                                <div className="flex flex-col w-full lg:h-64 h-40 gap-2 p-3 bg-gray-200">
                                                    <div className="bg-slate-50 w-full h-[80%] rounded-xl"></div>
                                                    <div className="bg-slate-50 w-full h-[10%] rounded-full"></div>
                                                    <div className="bg-slate-50 w-full h-[10%] rounded-full"></div>
                                                </div>
                                            </div>
                                        </SwiperSlide>
                                        {habitacion?.hotel_habitaciones_imagenes?.map(
                                            (imagen) => (
                                                <SwiperSlide key={imagen.id}>
                                                    <img
                                                        loading="lazy"
                                                        className=" lg:h-[50vh] h-[30vh] rounded-md swiper-lazy mx-auto"
                                                        alt="Imagen del producto"
                                                        data-src={`${process.env.REACT_APP_PROXY_ARCHIVOS}/blu/v1/hotel_habitaciones/getImage/${imagen.imagen}`}
                                                        data-srcset={`${process.env.REACT_APP_PROXY_ARCHIVOS}/blu/v1/hotel_habitaciones/getImage/${imagen.imagen}`}
                                                    />
                                                    <div className="swiper-lazy-preloader">
                                                        <div className="flex flex-col w-auto lg:h-[65vh] h-[30vh] gap-2 p-3 bg-gray-200">
                                                            <div className="bg-slate-50 w-full h-[80%] rounded-xl"></div>
                                                            <div className="bg-slate-50 w-full h-[10%] rounded-full"></div>
                                                            <div className="bg-slate-50 w-full h-[10%] rounded-full"></div>
                                                        </div>
                                                    </div>
                                                </SwiperSlide>
                                            )
                                        )}
                                    </Swiper>
                                </div>

                                <div className="lg:w-1/2 w-full flex flex-col items-center justify-center gap-4">
                                    {" "}
                                    <div className=" flex lg:flex-row flex-col lg:gap-10 gap-5  items-center justify-center  ">
                                        <div className=" text-lg text-center text-[#1C4CBB] align-middle ">
                                            <p className="font-light select-none">
                                                <span className="font-semibold">{`${
                                                    pedido.tipo_moneda
                                                } ${formatearNumero(
                                                    price_to_currency(
                                                        Number(
                                                            habitacion?.precio_base
                                                        ),
                                                        pedido.tipo_moneda
                                                    )
                                                )} `}</span>{" "}
                                                /por noche
                                            </p>
                                        </div>

                                        <div className=" h-20  border-l-2 border-[#1C4CBB] hidden lg:flex"></div>

                                        <div className="flex flex-col items-center justify-center  ">
                                            <CapacidadesHotel
                                                personas={
                                                    habitacion?.personas || ""
                                                }
                                                mascotas={
                                                    habitacion?.mascotas || ""
                                                }
                                                banos={habitacion?.banos || ""}
                                                camas={habitacion?.camas || ""}
                                                id_habitacion={
                                                    habitacion?.id || 0
                                                }
                                                toggleButton={false}
                                            />
                                        </div>
                                    </div>
                                    <div className="py-5 px-3 md:px-10 shadow-lg border border-gray-200 rounded-lg flex flex-col justify-center items-center w-full md:w-11/12  ">
                                        <div className="text-xl text-center font-semibold text-[#029BFC]">
                                            {!reserveVisible &&
                                                "Elije tus fechas para ver el precio de tu reserva"}
                                        </div>
                                        <div className=" w-5/6 mx-auto border-2 border-gray-500 rounded-lg  mt-4 ">
                                            <div className="flex divide-x-2 divide-gray-500 border-b-2 border-gray-500">
                                                <div
                                                    onClick={() =>
                                                        setModalCalendar(
                                                            !modalCalendar
                                                        )
                                                    }
                                                    className="flex-1 p-4 cursor-pointer"
                                                >
                                                    <p className="text-xs font-medium text-gray-800 uppercase">
                                                        LLEGADA
                                                    </p>
                                                    <p
                                                        className={`mt-1 text-sm font-semibold ${
                                                            dataReseve.fecha_inicial ===
                                                            "Selecciona una fecha"
                                                                ? "text-gray-500"
                                                                : "text-gray-800"
                                                        }`}
                                                    >
                                                        {
                                                            dataReseve.fecha_inicial
                                                        }
                                                    </p>
                                                </div>

                                                <div
                                                    onClick={() =>
                                                        setModalCalendar(
                                                            !modalCalendar
                                                        )
                                                    }
                                                    className="flex-1 p-4 cursor-pointer"
                                                >
                                                    <p className="text-xs font-medium text-gray-800 uppercase">
                                                        SALIDA
                                                    </p>
                                                    <p
                                                        className={`mt-1 text-sm font-semibold ${
                                                            dataReseve.fecha_final ===
                                                            "Selecciona una fecha"
                                                                ? "text-gray-500"
                                                                : "text-gray-800"
                                                        } `}
                                                    >
                                                        {dataReseve.fecha_final}
                                                    </p>
                                                </div>
                                            </div>

                                            <div
                                                onClick={() =>
                                                    handleModalHuespedes()
                                                }
                                                className="p-4 flex items-center justify-between cursor-pointer relative "
                                            >
                                                {modalHuespedes && (
                                                    <ModalHuespedes
                                                        modalRefCalendar={
                                                            modalRefCalendar
                                                        }
                                                        handleInputClick={
                                                            handleInputClick
                                                        }
                                                        huespedes={huespedes}
                                                        handleInputChange={
                                                            handleInputChange
                                                        }
                                                    />
                                                )}

                                                <div>
                                                    <p className="text-xs font-medium text-gray-800 uppercase">
                                                        HUÉSPEDES
                                                    </p>
                                                    <p className="mt-1 text-sm font-semibold text-gray-800">
                                                        {dataReseve.huespedes}{" "}
                                                        huésped
                                                    </p>
                                                </div>
                                                <div className="text-gray-500">
                                                    {modalHuespedes ? (
                                                        <svg
                                                            className="h-5 w-5 "
                                                            fill="none"
                                                            viewBox="0 0 24 24"
                                                            stroke="currentColor"
                                                        >
                                                            <path
                                                                strokeLinecap="round"
                                                                strokeLinejoin="round"
                                                                strokeWidth="2"
                                                                d="M5 15l7-7 7 7"
                                                            />
                                                        </svg>
                                                    ) : (
                                                        <svg
                                                            className="h-5 w-5 "
                                                            width="24"
                                                            height="24"
                                                            viewBox="0 0 24 24"
                                                            strokeWidth="2"
                                                            stroke="currentColor"
                                                            fill="none"
                                                            strokeLinecap="round"
                                                            strokeLinejoin="round"
                                                        >
                                                            {" "}
                                                            <path
                                                                stroke="none"
                                                                d="M0 0h24v24H0z"
                                                            />{" "}
                                                            <polyline points="6 9 12 15 18 9" />
                                                        </svg>
                                                    )}
                                                </div>
                                            </div>
                                        </div>

                                        {errorReserve ? (
                                            <div className="font-medium text-center text-red-500">
                                                {errorReserve}
                                            </div>
                                        ) : (
                                            <>
                                                {reserveVisible && (
                                                    <>
                                                        <div className="flex justify-between w-full py-2 border-y border-[#1C4CBB] text-[#1C4CBB] ">
                                                            <span className="mt-2 font-semibold">
                                                                Precio de
                                                                alquiler{" "}
                                                            </span>
                                                            <span className="mt-2 font-semibold">
                                                                {formatearNumero(
                                                                    Number(
                                                                        reserva.precio_alquiler
                                                                    )
                                                                )}{" "}
                                                                {
                                                                    pedido.tipo_moneda
                                                                }
                                                            </span>
                                                        </div>

                                                        {reserva.descuento_estadia ? (
                                                            <div className="flex justify-between w-full mt-4 font-semibold text-green-600">
                                                                <span className="">
                                                                    Descuento
                                                                    por larga
                                                                    estadía{" "}
                                                                </span>
                                                                <span className="font-medium text-end min-w-max">
                                                                    -{" "}
                                                                    {formatearNumero(
                                                                        Number(
                                                                            reserva.descuento_estadia
                                                                        )
                                                                    )}{" "}
                                                                    {
                                                                        pedido.tipo_moneda
                                                                    }
                                                                </span>
                                                            </div>
                                                        ) : null}

                                                        {Number(
                                                            reserva.garantia
                                                        ) !== 0 &&
                                                            habitacion.tipo_garantia ===
                                                                "Alquiler" && (
                                                                <div className="flex justify-between w-full py-2 text-[#1C4CBB] font-semibold">
                                                                    <span className="mt-2 ">
                                                                        Garantia{" "}
                                                                    </span>
                                                                    <span className="mt-2 ">
                                                                        {formatearNumero(
                                                                            Number(
                                                                                reserva.garantia
                                                                            )
                                                                        )}{" "}
                                                                        {}
                                                                    </span>
                                                                </div>
                                                            )}
                                                        {reserva
                                                            .servicios_adicionales
                                                            ?.length !== 0 && (
                                                            <div className="flex flex-col w-full gap-1 mt-4 text-left  border-t border-[#1C4CBB] text-[#1C4CBB] font-semibold">
                                                                <span className="mb-2 font-semibold ">
                                                                    Servicios
                                                                    adicionales
                                                                </span>
                                                                {reserva.servicios_adicionales?.map(
                                                                    (
                                                                        service
                                                                    ) => (
                                                                        <div
                                                                            key={
                                                                                service.id
                                                                            }
                                                                            className="flex items-center justify-between "
                                                                        >
                                                                            <div className="flex items-center gap-2">
                                                                                <span>
                                                                                    {
                                                                                        service.nombre
                                                                                    }
                                                                                </span>
                                                                            </div>

                                                                            {service.precio ? (
                                                                                <span className="font-medium">
                                                                                    {formatearNumero(
                                                                                        Number(
                                                                                            service.precio
                                                                                        )
                                                                                    )}{" "}
                                                                                    {
                                                                                        pedido.tipo_moneda
                                                                                    }{" "}
                                                                                </span>
                                                                            ) : null}
                                                                        </div>
                                                                    )
                                                                )}
                                                            </div>
                                                        )}

                                                        <div className="flex flex-col justify-center items-center mt-4 w-full border-t border-[#1C4CBB]">
                                                            <div className="w-full">
                                                                {reserva?.reserva_tours.map(
                                                                    (
                                                                        tour,
                                                                        index
                                                                    ) => (
                                                                        <div
                                                                            key={
                                                                                index
                                                                            }
                                                                        >
                                                                            <div className="flex justify-between w-full mt-2 items-center">
                                                                                <div className="flex items-center gap-2">
                                                                                    <span className="font-semibold">
                                                                                        Tour
                                                                                    </span>
                                                                                </div>

                                                                                <div className="flex items-center gap-2">
                                                                                    {
                                                                                        tour.tour
                                                                                    }
                                                                                </div>
                                                                            </div>

                                                                            <div className="flex justify-between w-full mt-2">
                                                                                <span className="font-semibold">
                                                                                    Turno
                                                                                </span>
                                                                                <span>
                                                                                    {formatearFecha(
                                                                                        tour.fecha
                                                                                    )}{" "}
                                                                                    (
                                                                                    {
                                                                                        tour.hora_inicio
                                                                                    }{" "}
                                                                                    -{" "}
                                                                                    {
                                                                                        tour.hora_final
                                                                                    }

                                                                                    )
                                                                                </span>
                                                                            </div>

                                                                            <div className="flex justify-between w-full mt-2">
                                                                                <span className="font-semibold">
                                                                                    Precio
                                                                                    Tour
                                                                                    por
                                                                                    persona
                                                                                </span>
                                                                                <span>
                                                                                    {formatearNumero(
                                                                                        Number(
                                                                                            tour.precio_tour_simple
                                                                                        )
                                                                                    )}{" "}
                                                                                    {
                                                                                        pedido.tipo_moneda
                                                                                    }{" "}
                                                                                    X
                                                                                    (
                                                                                    {Number(
                                                                                        tour
                                                                                            .personas
                                                                                            .adultos
                                                                                    ) +
                                                                                        Number(
                                                                                            tour
                                                                                                .personas
                                                                                                .ninos
                                                                                        )}{" "}
                                                                                    Personas)
                                                                                </span>
                                                                            </div>

                                                                            <div className="flex justify-between w-full mt-2">
                                                                                <span className="font-bold">
                                                                                    Precio
                                                                                    Tour
                                                                                </span>
                                                                                <span className="font-semibold">
                                                                                    {formatearNumero(
                                                                                        Number(
                                                                                            tour.precio_tour
                                                                                        )
                                                                                    )}{" "}
                                                                                    {
                                                                                        pedido.tipo_moneda
                                                                                    }
                                                                                </span>
                                                                            </div>

                                                                            <hr className="my-4 border-[#1C4CBB]" />
                                                                        </div>
                                                                    )
                                                                )}
                                                            </div>
                                                        </div>

                                                        <div className="flex justify-between w-full mt-1 font-bold pt-4 ">
                                                            <span className="">
                                                                Precio total Sin
                                                                IGV
                                                            </span>
                                                            <span className="">
                                                                {formatearNumero(
                                                                    Number(
                                                                        reserva.costo_subtotal
                                                                    )
                                                                )}{" "}
                                                                {
                                                                    pedido.tipo_moneda
                                                                }
                                                            </span>
                                                        </div>

                                                        <div className="flex justify-between w-full mt-1  font-bold pt-4 ">
                                                            <span className="">
                                                                IGV
                                                            </span>
                                                            <span className="">
                                                                {formatearNumero(
                                                                    Number(
                                                                        reserva.igv
                                                                    )
                                                                )}{" "}
                                                                {
                                                                    pedido.tipo_moneda
                                                                }
                                                            </span>
                                                        </div>

                                                        <div className="flex justify-between w-full mt-1 text-[#666666] font-bold border-t border-[#1C4CBB] pt-4 ">
                                                            <span className="">
                                                                Precio total de
                                                                la reserva:{" "}
                                                            </span>
                                                            <span className="">
                                                                {formatearNumero(
                                                                    Number(
                                                                        reserva.precio_total_reserva
                                                                    ) -
                                                                        Number(
                                                                            cupon
                                                                        )
                                                                )}{" "}
                                                                {
                                                                    pedido.tipo_moneda
                                                                }
                                                            </span>
                                                        </div>

                                                        {reserveVisible && (
                                                            <div
                                                                onClick={
                                                                    handleSubmit
                                                                }
                                                                className="w-5/6 p-3 bg-[#029BFC] text-white rounded-lg mt-4 cursor-pointer font-bold text-center hover:scale-105 transition-transform duration-300 mb-5"
                                                            >
                                                                Actualizar
                                                                reserva
                                                            </div>
                                                        )}

                                                        {Number(
                                                            reserva.garantia
                                                        ) !== 0 &&
                                                            habitacion.tipo_garantia ===
                                                                "Efectivo" && (
                                                                <div className="flex w-full px-1 mt-4 bg-blue-200 border-4 border-blue-300 rounded-lg">
                                                                    <span className="underline">
                                                                        Garantía:{" "}
                                                                    </span>
                                                                    <span className="ml-2 italic font-thin ">
                                                                        Deberás
                                                                        pagar{" "}
                                                                        {formatearNumero(
                                                                            price_to_currency(
                                                                                Number(
                                                                                    reserva.garantia
                                                                                ),
                                                                                pedido.tipo_moneda
                                                                            )
                                                                        )}{" "}
                                                                        {
                                                                            pedido.tipo_moneda
                                                                        }{" "}
                                                                        en
                                                                        efectivo
                                                                        al
                                                                        momento
                                                                        de
                                                                        llegar a
                                                                        la
                                                                        propiedad.
                                                                        (Reembolsable)
                                                                    </span>
                                                                </div>
                                                            )}
                                                    </>
                                                )}
                                            </>
                                        )}
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                )}
            </div>
        </ResponsiveModalAbsolute>
    );
};
